/* unplugin-vue-components disabled */import { render } from "./ReferenceInfo1.vue?vue&type=template&id=30ee796a&scoped=true&ts=true"
import script from "./ReferenceInfo1.vue?vue&type=script&lang=tsx"
export * from "./ReferenceInfo1.vue?vue&type=script&lang=tsx"

import "./ReferenceInfo1.vue?vue&type=style&index=0&id=30ee796a&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ee796a"]])

export default __exports__